import Vue from "vue";
import PageError from "@/views/PageError.vue";
import loadConfig from "../loadConfig";

export default function() {
  return loadConfig()
    .then(() => import("./"))
    .then(({ createApp }) => ({ app: createApp() }))
    .catch(e => ({
      app: new Vue({ render: h => h(PageError, { props: { error: e } }) }),
    }));
}
